import React from "react"
import { Formik, Form, Field, FormikHelpers, useFormik } from "formik"
import * as Yup from "yup"
import { Input, InputWrapper } from "../composites"
import { Grid } from "@chakra-ui/layout"
import { Select } from "@chakra-ui/select"
import _ from "lodash"
import { Button } from "@chakra-ui/button"
import {
  changeGroupService,
  changePassword,
  createTransaction,
  createUser,
} from "../../services/crm.service"
import { useShowToastHook } from "../../hooks/show-toast-hook"
import ErrorBoundary from "../ErrorBoundary"

const TYPE = {
  DEPOSIT: "Deposit",
  WITHDRAW: "Withdraw",
  CREDIT_IN: "Credit In",
  CREDIT_OUT: "Credit Out",
}

//group f_name m_name l_name  master_password investor_password  email phone company country zipcode state city address
const userSchema = Yup.object().shape({
  login: Yup.number().required("Login ID is required"),
  group: Yup.string().required("Group is required!"),
})

const ChangeUserGroupForm = ({ groups }: { groups: string }) => {
  const { showError, showSuccess } = useShowToastHook()

  const formik = useFormik({
    initialValues: {
      login: undefined,
      group: undefined,
    },
    validationSchema: userSchema,
    onSubmit: async (values, actions) => {
      actions.setSubmitting(true)

      try {
        const result = await changeGroupService(values)

        if (result?.data?.status) {
          showSuccess("User group change successfully.")
          actions.resetForm()
        } else {
          showError(
            result?.data?.message ??
              "Something went wrong, please try again later."
          )
        }
      } catch (error) {
        showError("Something went wrong, please try again later.")
      }

      actions.setSubmitting(false)
    },
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          my={6}
          gap={6}
          width="100%"
          maxWidth={["100%", "100%", "900px", "900px"]}
        >
          <Input
            title="Login"
            type="number"
            name="login"
            value={formik?.values?.login}
            onChange={formik?.handleChange}
            onBlur={formik?.handleBlur}
            errorMessage={
              formik?.touched?.login && formik?.errors?.login
                ? formik?.errors?.login
                : ""
            }
          />

          <ErrorBoundary>
            <InputWrapper
              title="Group"
              errorMessage={
                formik?.touched?.group && formik?.errors?.group
                  ? formik?.errors?.group
                  : ""
              }
            >
              <Select
                name="group"
                value={formik?.values?.group}
                onChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
              >
                <option value={undefined}>Select Group</option>
                {_.map(groups ?? [], (_g) => {
                  if (typeof _g != "string") return null

                  return <option value={_g}> {_g} </option>
                })}
              </Select>
            </InputWrapper>
          </ErrorBoundary>

          <Button
            colorScheme="blue"
            type="submit"
            isLoading={formik?.isSubmitting}
          >
            Change Group
          </Button>
        </Grid>
      </form>
    </>
  )
}

export default ChangeUserGroupForm
